export enum AccountType {
  individual = 'INDIVIDUAL',
  organisation = 'ORGANISATION',
  commercial = 'COMMERCIAL',
}
